import { Link, useLocation } from 'react-router-dom'

import { PAGES, langForPath } from '../i18n'
import styles from './NotFoundPage.module.css'

/**
 * A real 404, not a redirect home.
 *
 * Azure serves this file for any unmatched path (responseOverrides in
 * staticwebapp.config.json) with a real 404 status, so a broken link stays visibly
 * broken instead of quietly turning into the home page.
 */
const COPY = {
  sv: {
    title: 'Sidan finns inte',
    body: 'Länken kan vara gammal, eller så har adressen ändrats.',
    home: 'Till startsidan',
  },
  en: {
    title: 'This page does not exist',
    body: 'The link may be old, or the address may have changed.',
    home: 'Go to the home page',
  },
}

export default function NotFoundPage() {
  const { pathname } = useLocation()
  const lang = langForPath(pathname)
  const t = COPY[lang]

  return (
    <div className={`container--reading ${styles.wrap}`}>
      <h1 className={styles.title}>{t.title}</h1>
      <p className={styles.body}>{t.body}</p>
      <Link to={PAGES.home[lang]} className={styles.link}>
        {t.home}
      </Link>
    </div>
  )
}
